
<div class="social-auth">
  <btn
    block
    kind="google"
    class="google-button"
    :loading="submitting"
    loading-text=""
    :disabled="submitting"
    @click="googleLogin"
  >
    <align small-gap>
      <img
        class="google-icon"
        alt="Google Sign In"
        src="@/assets/google-icon.svg"
        width="15"
      />

      <span>{{ isLogin ? 'Sign in with Google' : 'Sign up with Google' }}</span>
    </align>
  </btn>

  <btn
    block
    kind="apple"
    class="apple-button"
    :loading="submitting"
    loading-text=""
    :disabled="submitting"
    @click="appleLogin"
  >
    <align small-gap>
      <img
        class="apple-icon"
        alt="Apple Sign In"
        src="@/assets/apple-icon.svg"
        width="15"
      />

      <span>{{ isLogin ? 'Sign in with Apple' : 'Sign up with Apple' }}</span>
    </align>
  </btn>
</div>
